
const state = {
    customer: null,
    newCustomer: false,
    stay:null
};

const mutations = {
    setCustomerData(state, data) {
        state.customer = data;
    },
    resetCustomer(state) {
        state.customer = null;
        state.newCustomer = false;
    },
    setNewCustomer(state, data){
        state.newCustomer = data;
    },
    setStayData(state, data){
        state.stay = data;
    },
    resetStay(state) {
        state.stay = null;
    },
};

const actions = {
    saveCustomer({ commit }, customer) {
        commit('setCustomerData',customer)
    },
    saveNewCustomer({ commit }, is_new_customer) {
        commit('setNewCustomer',is_new_customer)
    },
    saveStayData({ commit }, stay) {
        commit('setStayData',stay)
    },
    resetCustomer({ commit }) {
        commit('resetCustomer')
    },
    resetStay({ commit }) {
        commit('resetStay')
    },
};
const getters = {
    getCustomer (state) {
        return state.customer
    },
    getIsNewCustomer (state) {
        return state.newCustomer
    },
    getStay (state) {
        return state.stay
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};